<template>
  <div class="fileStyleName" :title="dwgFileName">
    <img src="./../images/title.png" alt="图标">
    <span>{{ dwgFileName }}</span>
  </div>
</template>

<script>
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
export default {
  computed: {
    dwgdata() {
      return JSON.parse(mongeApp.map.fileInfo);
    },
    dwgFileName() {
      return decodeURIComponent(this.dwgdata.fileName) || "未命名";
    }
  }
};
</script>

<style lang="scss" scoped>
.fileStyleName{
  position: absolute;
  max-width: 85%;
  height: 40px;
  top: 0px;
  border-bottom-right-radius: 10px;
  background: rgba(255, 255, 255, 0.51);

  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  img{
    width: 25px;
    height: 25px;
    object-fit: contain;
  }
  span{
    width: 100%;
    color: #fff;
    line-height: 40px;
    font-size: 14px;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    user-select: none;
    text-indent: 3px;
  }
}
</style>
